var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "arrowUp_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m18.71 9.38-6.05-6.11a1 1 0 0 0-.71-.3 1 1 0 0 0-.71.3L5.29 9.35a.987.987 0 0 0 .02 1.41c.4.39 1.03.38 1.41-.02l4.23-4.32v13.61c0 .55.45 1 1 1s1-.45 1-1V6.4l4.34 4.39a.99.99 0 0 0 1.41.01c.39-.39.4-1.02 0-1.41z"
})));
export default SvgArrowUp;